import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Color } from "config/colors";
import "react-tooltip/dist/react-tooltip.css";
import {
  Text,
  ClockStampCreateAutoGeneratedGigBody,
  Row,
  Container1,
  Container2,
  Container3,
} from "./clockStamp.styled";
import { FontFamily, FontSize } from "config/font";
import { Modal } from "@material-ui/core";
import { TimeReportForStamping, TimeReportsForStamping } from "model/Company";
import moment from "moment-timezone";
import { ButtonComponent } from "../general/button/button.component";

type Props = {
  setShowChooseTimeReportModal: React.Dispatch<React.SetStateAction<boolean>>;
  setKeyShouldBeDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  showChooseTimeReportModal: boolean;
  setTimeReport: React.Dispatch<
    React.SetStateAction<TimeReportForStamping | undefined>
  >;
  clearInputs: () => void;
  handleCheckInCheckOut: () => void;
  timeReport: TimeReportForStamping | undefined;
  workerTimeReports: TimeReportsForStamping | null;
};

export const ClockStampChooseTimeReportModal: React.FC<Props> = ({
  setShowChooseTimeReportModal,
  setKeyShouldBeDisabled,
  showChooseTimeReportModal,
  setTimeReport,
  clearInputs,
  handleCheckInCheckOut,
  timeReport,
  workerTimeReports,
}) => {
  const { t } = useTranslation();

  const handleCloseModal = () => {
    setShowChooseTimeReportModal(false);
    setKeyShouldBeDisabled(false);
    clearInputs();
  };

  const formatTime = (time?: string | null) => {
    if (!time) return "—";
    return moment.tz(time, "UTC").tz("Europe/Stockholm").format("HH:mm");
  };

  const formatDate = (time: string) => {
    return moment.tz(time, "UTC").tz("Europe/Stockholm").format("YYYY-MM-DD");
  };

  useEffect(() => {
    if (timeReport !== undefined) {
      handleCheckInCheckOut();
    }
  }, [timeReport]);

  return (
    <>
      <Modal
        open={showChooseTimeReportModal}
        onClose={handleCloseModal}
        aria-labelledby="choose-time-report-title"
        aria-describedby="choose-time-report-description"
      >
        <ClockStampCreateAutoGeneratedGigBody>
          <Text
            id="choose-time-report-title"
            fontFamily={FontFamily.MontserratSemiBold}
            fontSize={FontSize.H3}
            color={Color.MidnightBlue}
          >
            {t("StampClock.ChooseTimeReportForStamping")}
          </Text>

          <Text
            id="choose-time-report-description"
            fontFamily={FontFamily.MontserratRegular}
            fontSize={FontSize.Standard}
            color={Color.MidnightBlue}
          >
            {t("StampClock.ChooseTimeReportForStampingInfo")}
          </Text>

          {workerTimeReports &&
            workerTimeReports?.timeReports.map((tr) => {
              return (
                <Row key={tr.timeReportId}>
                  <Container1>
                    <Text style={{ marginTop: 10 }}>
                      {formatDate(tr.startTime)}
                    </Text>
                  </Container1>

                  <Container2>
                    <Text style={{ marginTop: 10 }}>
                      {`${formatTime(tr.startTime)}-${formatTime(tr.endTime)}`}
                    </Text>
                  </Container2>

                  <Container3>
                    <ButtonComponent
                      size="small"
                      onClick={() => {
                        if (!workerTimeReports) return;
                        const selected: TimeReportForStamping = {
                          ...tr,
                          companyId: workerTimeReports.companyId,
                          workerPhoneNumber:
                            workerTimeReports.workerPhoneNumber,
                        };
                        setTimeReport(selected);
                      }}
                      action={true}
                      marginBottom={20}
                    >
                      {tr.checkInTime == null
                        ? t("StampClock.CheckIn")
                        : t("StampClock.CheckOut")}
                    </ButtonComponent>
                  </Container3>
                </Row>
              );
            })}
        </ClockStampCreateAutoGeneratedGigBody>
      </Modal>
    </>
  );
};
